import React, { useState } from "react";
import CheckedIcon from "../../icons/dashboard/CheckedIcon";
interface StepperProps {
  currentStep: number;
  Steps: number;
  completedSteps: any;
  handleOnClick?: any;
}
const Stepper = ({
  currentStep,
  Steps,
  completedSteps,
  handleOnClick,
}: StepperProps) => {
  const totalSteps = Array.from(Array(Steps).keys());
  const totalLines = Array.from(Array(Steps - 1).keys());

  const calcProgress = () => {
    const devideWidth = 100 / (Steps - 1);
    return devideWidth;
  };
  calcProgress();

  return (
    <>
      <div className="relative h-[32px] flex items-center w-full">
        <div className="flex w-full gap-x-[32px] mx-[32px]">
          {totalLines.map((itm, index) => (
            <div
              key={index}
              style={{
                width: `${calcProgress()}%`,
              }}
              className={`h-[1px] flex`}
            >
              <div
                className={`${
                  completedSteps.includes(itm)
                    ? itm === currentStep - 1
                      ? "bg-blue"
                      : "bg-btnOutlineStroke"
                    : "bg-strokePrimary"
                } w-1/2 h-full`}
              />
              {completedSteps.includes(itm) &&
                itm === currentStep - 1 &&
                Array.from(Array(10).keys()).map((itm, index) => {
                  return <div key={index} className={`bg-blue w-full `} />;
                })}
              {completedSteps.includes(itm) && itm === currentStep - 1 ? (
                Array.from(Array(20).keys()).map((itm, index) => {
                  return (
                    <div
                      key={index}
                      className={`${
                        itm % 2 === 0 ? "bg-blue" : "bg-transparent"
                      } w-full `}
                    />
                  );
                })
              ) : (
                <div
                  className={`${
                    completedSteps.includes(itm)
                      ? itm === currentStep - 1
                        ? "bg-blue"
                        : "bg-btnOutlineStroke"
                      : "bg-strokePrimary"
                  } w-1/2 h-full`}
                />
              )}
            </div>
          ))}
        </div>
        <div className="absolute w-full flex justify-between">
          {totalSteps.map((itm, index) => (
            <div
              key={index}
              className={`min-w-[32px] w-[32px] h-[32px] ${
                completedSteps.includes(itm)
                  ? itm === currentStep - 1
                    ? "bg-blue text-white border-blue "
                    : "bg-white border-btnOutlineStroke cursor-pointer"
                  : "bg-bgPrimary border-strokePrimary text-txtSecondary"
              } rounded-full border-[1px] flex justify-center items-center text-base cursor-pointer`}
              onClick={() => {
                if (completedSteps.includes(itm)) {
                  handleOnClick(itm+1);
                }
              }}
            >
              {completedSteps.includes(itm) ? (
                itm === currentStep - 1 ? (
                  itm + 1
                ) : (
                  <CheckedIcon />
                )
              ) : (
                itm + 1
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Stepper;
